export const OBJECTIVE_PAGE_DESCRIPTION = `
Unpack learning competencies to create meaningful class objectives.
The class objectives are aligned with the 3 learning domains 
(Cognitive, Affective, Psychomotor)`;

export const IPLAN_OBJECTIVE_PAGE_DESCRIPTION = `
Transform unpacked learning competencies into meaningful class objectives.
The class objectives are aligned with the 3 learning domains 
(Cognitive, Psychomotor, Affective-Attitudes and Affective-Values)`;

export const OBJECTIVE_TITLE = 'Objectives';
export const IP_OBJECTIVE_TITLE = 'Iplan Objectives';

export const OBJECTIVE_TUTORIAL_DESKTOP_URL = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/tutorials/tutorialObjectiveDesktop.webp`;
export const OBJECTIVE_TUTORIAL_MOBILE_URL = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/tutorials/tutorialObjectiveMobile.webp`;
export const IP_OBJECTIVE_TUTORIAL_DESKTOP_URL = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/tutorials/tutorialIplanObjectiveDesktop.webp`;
export const IP_OBJECTIVE_TUTORIAL_MOBILE_URL = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/tutorials/tutorialIplanObjectiveMobile.webp`;
